// Note: The first file of a module here, must also register the module

import "./access-token-dialog.component";
import "./public-api.component";
